export default __webpack_public_path__ + "static/grid2022-cover3d-e43f871b10dfdb22ea47a728f7e090cc.png";